<template>
    <div>
        <component-header
            title="Edit User"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push('/user')"
        />
        <b-card>
            <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
                <div>
                    <h3 class="mx-3" style="color: var(--primary)">
                        User Information
                    </h3>
                    <b-row>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="first name">First Name:</label>
                                    <ValidationProvider
                                        rules="required|alpha_spaces"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            inputType="text"
                                            inputId="FirstName"
                                            placeholder="Enter Name"
                                            v-model="currentUser.name.first"
                                            class="mt-0"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5 class="h5-text p-2">
                                    <label for="email">Email:</label>
                                    <ValidationProvider
                                        rules="required|email"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            inputType="text"
                                            inputId="Email"
                                            placeholder="Enter Email"
                                            v-model="
                                                currentUser.authentication.email
                                            "
                                            class="mt-0"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5 class="h5-text p-2">
                                    <label for="education">Education:</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            inputType="text"
                                            inputId="Education"
                                            placeholder="Enter Education"
                                            v-model="currentUser.education"
                                            class="mt-0"
                                        ></b-form-input>
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <b-row>
                                    <b-col md="6">
                                        <h5 class="h5-text p-2">
                                            <label for="working experience"
                                                >Working Experience:</label
                                            >
                                            <ValidationProvider
                                                rules="required|numeric"
                                                v-slot="{ errors }"
                                            >
                                                <b-form-input
                                                    inputType="number"
                                                    inputId="Experience"
                                                    placeholder="Enter Working Experience"
                                                    v-model="
                                                        currentUser.experience
                                                            .value
                                                    "
                                                    class="mt-0"
                                                />
                                                <span
                                                    class="validate-error custm-err"
                                                    >{{ errors[0] }}</span
                                                >
                                            </ValidationProvider>
                                        </h5>
                                    </b-col>
                                    <b-col md="6">
                                        <h5 class="h5-text p-1">
                                            <label
                                                for="UOM"
                                                style="margin-top: 20px"
                                                >UOM:</label
                                            >
                                            <ValidationProvider
                                                rules="required"
                                                v-slot="{ errors }"
                                            >
                                                <eb-select
                                                    type="text"
                                                    :selected="
                                                        currentUser.experience
                                                            .uom
                                                    "
                                                    v-model="
                                                        currentUser.experience
                                                            .uom
                                                    "
                                                    :options="[
                                                        'Days',
                                                        'Months',
                                                        'Years',
                                                    ]"
                                                    label="label"
                                                    placeholder="UOM"
                                                ></eb-select>
                                                <span
                                                    class="validate-error custm-err"
                                                    >{{ errors[0] }}</span
                                                >
                                            </ValidationProvider>
                                        </h5>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="last name">Last Name:</label>
                                    <ValidationProvider
                                        rules="required|alpha_spaces"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            inputType="text"
                                            inputId="LastName"
                                            placeholder="Enter Last Name"
                                            v-model="currentUser.name.last"
                                            class="mt-0"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5 class="h5-text p-2">
                                    <label for="gender">Gender:</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <eb-select
                                            type="text"
                                            v-model="currentUser.gender"
                                            :selected="currentUser.gender"
                                            :options="[
                                                'Female',
                                                'Male',
                                                'Others',
                                            ]"
                                            label="label"
                                            placeholder="Select Gender"
                                        ></eb-select>
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5
                                    class="h5-text"
                                    style="width: 240px; margin-left: 10px"
                                >
                                    <label style="margin-left: 10px" for="dob"
                                        >DOB:</label
                                    >
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            id="activation-date"
                                            type="date"
                                            v-model="currentUser.dob"
                                        ></b-form-input>
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="phone number"
                                        >Phone Number:</label
                                    >
                                    <ValidationProvider
                                        rules="required|max:15|min:10"
                                        v-slot="{ errors }"
                                        name="Phone Number"
                                    >
                                        <c-tel-input
                                            v-model="
                                                currentUser.authentication.phone
                                            "
                                            :defaultInput="
                                                currentUser.authentication.phone
                                            "
                                            class="m-0"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5 class="h5-text p-2">
                                    <label
                                        style="margin-top: 6px"
                                        for="marital status"
                                        >Marital Status:</label
                                    >
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <eb-select
                                            type="text"
                                            :selected="
                                                currentUser.maritalStatus
                                            "
                                            v-model="currentUser.maritalStatus"
                                            :options="['Single', 'Married']"
                                            label="label"
                                            placeholder="Select Marital Status"
                                        ></eb-select>
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5>
                                    <label
                                        class="profile photo"
                                        for="profile photo"
                                        >profile photo:
                                    </label>
                                </h5>
                                <div style="margin-left: 20px">
                                    <single-image
                                        height="150px"
                                        width="130px"
                                        @change="
                                            (d) =>
                                                uploadImage('profilePhoto', d)
                                        "
                                        :id="'profilePhoto'"
                                        :url="currentUser.profilePhoto"
                                    ></single-image>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <hr
                        style="border-top: 1px dashed var(--primary)"
                        class="mt-2"
                    />
                    <h3 class="mx-3" style="color: var(--primary)">
                        User Address
                    </h3>
                    <b-row>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="city">City:</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            type="text"
                                            inputId="city"
                                            v-model="currentUser.address.city"
                                            placeholder="Enter City"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                                <h5 class="h5-text p-2">
                                    <label for="zipcode">Zipcode:</label>
                                    <ValidationProvider
                                        rules="required|digits:6"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            inputType="number"
                                            inputId="zipcode"
                                            v-model="currentUser.address.zip"
                                            placeholder="Enter Zipcode"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="state">State:</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            type="text"
                                            inputId="state"
                                            v-model="currentUser.address.state"
                                            placeholder="Enter State"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="country">Country:</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Country"
                                    >
                                        <b-form-input
                                            type="text"
                                            inputId="state"
                                            v-model="
                                                currentUser.address.country
                                            "
                                            placeholder="Enter Country"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                            </div>
                        </b-col>
                    </b-row>
                    <hr
                        style="border-top: 1px dashed var(--primary)"
                        class="mt-2"
                    />
                    <h3 class="mx-3" style="color: var(--primary)">
                        User Access
                    </h3>
                    <b-row>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="user name">User Name:</label>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            type="text"
                                            inputId="userName"
                                            v-model="
                                                currentUser.authentication
                                                    .userName
                                            "
                                            placeholder="Enter User Name"
                                        />
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <label for="category">Category:</label>
                                    <eb-select
                                        type="text"
                                        inputId="category"
                                        label="label"
                                        :options="categoryOptions"
                                        v-model="currentUser.category"
                                        :selected="currentUser.category"
                                        placeholder="Enter Access Level"
                                    ></eb-select>
                                </h5>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="mx-3">
                                <h5
                                    class="h5-text p-2"
                                    v-if="$userRole == 'Tenant'"
                                >
                                    <label for="access level"
                                        >Access Level:</label
                                    >
                                    <b-form-input
                                        type="text"
                                        inputId="orgAccessLevel"
                                        readonly
                                        v-model="
                                            currentUser.authorization.orgAccess
                                                .orgAccessLevel
                                        "
                                        placeholder="Enter Access Level"
                                    />
                                </h5>
                            </div>
                        </b-col>
                    </b-row>
                    <hr
                        style="border-top: 1px dashed var(--primary)"
                        class="mt-2"
                    />
                    <h3 class="mx-3" style="color: var(--primary)">
                        Other Information
                    </h3>
                    <b-row>
                        <b-col md="12">
                            <div class="mx-3">
                                <h5 class="h5-text p-2">
                                    <h5>About Me:</h5>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="About Me"
                                    >
                                        <textarea
                                            id="AboutMe"
                                            rows="3"
                                            cols="40"
                                            class="p-1"
                                            style="border: 1px solid grey"
                                            inputType="text"
                                            v-model="currentUser.aboutMe"
                                        ></textarea>
                                        <span
                                            class="validate-error custm-err"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </h5>
                            </div>
                        </b-col>
                    </b-row>
                    <hr
                        style="border-top: 1px dashed var(--primary)"
                        class="mt-2"
                    />
                    <template>
                        <b-button
                            size="sm"
                            class="mr-2 my -0 main-navigation-button mx-3"
                            variant="primary"
                            v-b-modal.modal-1
                            @click="kycByUser"
                        >
                            KYC Details
                        </b-button>
                        <b-modal
                            id="modal-1"
                            title="KYC Details"
                            scrollable
                            size="lg"
                            centered
                            hide-footer
                            ref="modal1"
                        >
                            <b-row v-if="isloading">
                                <b-col md="12" class="text-center">
                                    <h4>Loading....</h4>
                                </b-col>
                            </b-row>
                            <b-row
                                class="px-5 py-2"
                                v-else-if="
                                    kycUser &&
                                    kycUser.documents &&
                                    kycUser.documents.length > 0
                                "
                            >
                                <b-col
                                    md="8"
                                    lg="12"
                                    class="justify-content-center"
                                    :key="i"
                                    v-for="(kyc, i) in kycUser.documents"
                                >
                                    <b-row>
                                        <h5 class="h5-text p-2">
                                            {{ kyc.docType }} :
                                            <span class="span-text">{{
                                                kyc.docuementNo
                                            }}</span>
                                        </h5>
                                    </b-row>
                                    <b-row>
                                        <h5 class="h5-text pl-2">
                                            Document Type :
                                            <span class="span-text">{{
                                                kyc.docType
                                            }}</span>
                                        </h5>
                                    </b-row>
                                    <b-row>
                                        <h5 class="h5-text p-2">Photo :</h5>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6">
                                            <a
                                                target="_blank"
                                                :href="kyc.frontSideFilePath"
                                            >
                                                <img
                                                    :src="kyc.frontSideFilePath"
                                                    height="200px"
                                                    width="300px"
                                                    class="border-img-doc"
                                                />
                                            </a>
                                            <label>Front Side</label>
                                        </b-col>
                                        <b-col md="6">
                                            <a
                                                target="_blank"
                                                :href="kyc.backSideFilePath"
                                            >
                                                <img
                                                    :src="kyc.backSideFilePath"
                                                    height="200px"
                                                    width="300px"
                                                    class="border-img-doc"
                                                />
                                            </a>
                                            <label>Back Side</label>
                                        </b-col>
                                    </b-row>
                                    <hr />
                                </b-col>
                            </b-row>
                            <b-row
                                class="px-5 py-2"
                                v-if="
                                    kycUser &&
                                    kycUser.documents &&
                                    kycUser.documents.length
                                "
                                ><b-col>
                                    <button
                                        type="button"
                                        class="btn btn-lg btn-outline-primary ml-5 w-50"
                                        @click="updateKyc()"
                                    >
                                        Edit KYC
                                    </button>
                                </b-col>
                                <b-col>
                                    <button
                                        type="button"
                                        class="btn btn-lg btn-danger ml-5 w-50"
                                        @click="cancelButton()"
                                    >
                                        Cancel
                                    </button>
                                </b-col>
                            </b-row>
                            <b-row v-else>
                                <b-col class="text-center">
                                    <h4>Kyc Data Not Found</h4>
                                    <button
                                        type="button"
                                        class="btn btn-lg btn-outline-primary ml-3 w-25"
                                        @click="createKyc()"
                                    >
                                        Create KYC
                                    </button>
                                </b-col>
                            </b-row>
                        </b-modal>
                    </template>
                </div>
                <div class="text-center mb-5 mt-5">
                    <button
                        type="button"
                        :disabled="invalid"
                        class="btn btn-lg btn-success ml-3 w-23s"
                        @click.prevent="handleSubmit"
                    >
                        Update
                    </button>
                </div>
            </ValidationObserver>
        </b-card>
    </div>
</template>
<script>
import { getReverseGeoCode } from "@/services/geocode";
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select";
import ebButton from "@/components/FormElements/Button";
import { mapActions, mapGetters } from "vuex";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
import {
    ValidationObserver,
    ValidationProvider,
    Validator,
} from "vee-validate";
export default {
    name: "Edituser",
    components: {
        ebButton,
        SingleImage,
        cTelInput,
        ComponentHeader,
        ebSelect,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            isloading: false,
            currentUser: {
                name: {
                    first: "",
                    last: "",
                },

                gender: "",
                experience: {
                    value: "",
                    uom: "",
                },
                maritalStatus: "",
                education: "",
                dob: "",
                profilePhoto: "",
                address: {
                    state: "",
                    city: "",
                    country: "",
                    zip: "",
                },
                authentication: {
                    userName: "",

                    phone: "",
                    email: "",
                },
                aboutMe: "",
            },
        };
    },
    computed: {
        ...mapGetters({
            kycUser: "tenant/GetKycByUser",
        }),
        categoryOptions() {
            return [
                { label: "DELIVERY_AGENT", value: "DELIVERY_AGENT" },
                { label: "DRIVER", value: "DRIVER" },
                { label: "DOCTOR", value: "DOCTOR" },
                { label: "PHYSIOTHERAPIST", value: "PHYSIOTHERAPIST" },
                {
                    label: "CollectionAgent_Diagnostic",
                    value: "CollectionAgent_Diagnostic",
                },
                { label: "CLEANING", value: "CLEANING" },
                { label: "COOKING", value: "COOKING" },
                { label: "BABY_SITTING", value: "BABY_SITTING" },
                { label: "ELDERLY_CARE", value: "ELDERLY_CARE" },
                { label: "PLUMBER", value: "PLUMBER" },
                { label: "CARPENTER", value: "CARPENTER" },
                { label: "PEST_CONTROL", value: "PEST_CONTROL" },
                { label: "APPLIANCE_REPAIR", value: "APPLIANCE_REPAIR" },
                { label: "SALOON_SPA", value: "SALOON_SPA" },
                { label: "ELECTRICIAN", value: "ELECTRICIAN" },
                { label: "PAINTER", value: "PAINTER" },
            ];
        },
    },
    methods: {
        async viewManagemtDetail() {
            await this.$store
                .dispatch(
                    "tenant/viewUserManagementDetail",
                    this.$route.params.id,
                )
                .then((res) => {
                    set: {
                        this.currentUser = res;
                    }
                });
        },
        createKyc() {
            this.$router.push({
                name: "CreateKyc",
                params: { userData: this.currentUser },
            });
        },
        updateKyc() {
            this.$router.push({
                name: "UpdateKyc",
                params: {
                    userData: this.currentUser,
                    kycData: this.kycUser.documents,
                },
                query: { mode: "update" },
            });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        async uploadImage(path, image) {
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["agent", "profilePhoto"],
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    this.clearCustomToast();
                    this.currentUser[path] = res.data.fileUrl;
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        handleSubmit() {
            const data = {
                _id: this.currentUser._id,
                payload: {
                    name: {
                        first: this.currentUser.name.first,
                        last: this.currentUser.name.last,
                    },
                    email: this.currentUser.authentication.email,
                    phone: this.currentUser.authentication.phone,
                    gender: this.currentUser.gender,
                    education: this.currentUser.education,
                    profilePhoto: this.currentUser.profilePhoto,
                    authentication: {
                        userName: this.currentUser.authentication.userName,
                    },
                    dob: this.currentUser.dob,
                    experience: {
                        value: this.currentUser.experience.value,
                        uom: this.currentUser.experience.uom,
                    },
                    aboutMe: this.currentUser.aboutMe,
                    category: this.currentUser.category.value,
                    maritalStatus: this.currentUser.maritalStatus,
                    address: {
                        state: this.currentUser.address.state,
                        city: this.currentUser.address.city,
                        country: this.currentUser.address.country,
                        zip: this.currentUser.address.zip,
                    },
                },
            };
            this.$store.dispatch("partner/updateUser", data).then(() => {
                this.$swal({
                    title: "Success",
                    text: "User updated successfully!!",
                    type: "success",
                });
                this.$router.push("/user");
            });
        },
        async kycByUser() {
            this.isloading = true;
            const data = await this.$store
                .dispatch("tenant/fetchKYCListByUser", {
                    id: this.currentUser._id,
                })
                .then((res) => {});
            this.isloading = false;
        },
        cancelButton() {
            this.$refs.modal1.hide();
        },
    },
    mounted: async function () {
        this.loading = true;
        Object.assign(this.currentUser, this.$route.params.userData);
        this.loading = false;
        this.viewManagemtDetail();
    },
};
</script>

<style scoped>
.border-img-doc {
    border: 2px solid black;
    border-radius: 5px;
}

.card {
    border-width: inherit;
    border-radius: 2px;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
    background-color: aliceblue !important;
}

[btn-back="primary"] {
    background-color: var(--primary) !important;
    margin: 0px;
    height: 41px;
    color: white;
}
</style>
<style>
.footer-bottons-class {
    text-align: center;
    background: var(--primary) !important;
    margin-left: 40%;
}

.span-text {
    font-size: 15px;
    font-weight: normal;
    line-height: 24px;
}

.h5-text {
    font-size: 15px;
    line-height: 17px;
}
.modal-header {
    background-color: var(--primary) !important;
}
.modal-title {
    margin-left: 0;
}
</style>
